import { Component, Input } from '@angular/core';

/**
 * Used to work around i18n limitations
 */
@Component({
    selector: '[render-day-of-week]',
    template: `
@switch (day) {
  @case ('Monday') {
    <ng-container i18n="Day of week - Monday@@day.of.week.monday">
        Monday
      </ng-container>
  }
  @case ('Tuesday') {
    <ng-container i18n="Day of week - Tuesday@@day.of.week.tuesday">
        Tuesday
      </ng-container>
  }
  @case ('Wednesday') {
    <ng-container i18n="Wednesday@@day.of.week.wednesday">
        Wednesday
      </ng-container>
  }
  @case ('Thursday') {
    <ng-container i18n="Thursday@@day.of.week.thursday">
        Thursday
      </ng-container>
  }
  @case ('Friday') {
    <ng-container i18n="Day of week - Friday@@day.of.week.friday">
        Friday
      </ng-container>
  }
  @case ('Saturday') {
    <ng-container i18n="Day of week - Saturday@@day.of.week.saturday">
        Saturday
      </ng-container>
  }
  @case ('Sunday') {
    <ng-container i18n="Day of week - Sunday@@day.of.week.sunday">
        Sunday
      </ng-container>
  }
}
`,
    standalone: true
})
export class RenderDayOfWeekComponent {
  @Input() day: string;
}
